"use strict";
var _ = require("lodash");

module.exports /* @ngInject */ = function(
  $log,
  $q,
  eikonSsoService,
  sideBySideApi,
  RediWindowFactory,
  RediPlusWindowRepository
) {
  var that = this;

  that.init = function() {
    $log.info("Registering sideBySide");
    return eikonSsoService.getEikonToken().then(function(eikonToken) {
      $log.info("received Eikon Token");
      return sideBySideApi
        .waitUntilReady()
        .then(function() {
          $log.info("Logging in with Token.");
          return sideBySideApi.loginWithToken(eikonToken);
        })
        .then(function() {
          return handshakeAndFinalize();
        });
    });
  };

  that.initExistingInstance = function(instanceId) {
    $log.info("re-initializing sxs instance to " + instanceId);
    return sideBySideApi.closeSession().then(function() {
      return handshakeAndFinalize(instanceId).then(function() {
        return registerPreviouslyOpenedRediWindows();
      });
    });
  };

  function registerPreviouslyOpenedRediWindows() {
    var rediPlusExistingWindows = RediPlusWindowRepository.getAllWindows();
    var promisedRediPlusWindowsOpened = _.map(rediPlusExistingWindows, function(
      rediPlusWindow
    ) {
      return sideBySideApi.rediPlusWindowOpened(
        rediPlusWindow.windowName,
        rediPlusWindow.windowType,
        rediPlusWindow.sideBySideInstanceId
      );
    });

    return $q.all(promisedRediPlusWindowsOpened);
  }

  function handshakeAndFinalize(maybeExistingInstanceId) {
    $log.info("SxS handshake.");
    return sideBySideApi
      .handshake(maybeExistingInstanceId)
      .then(establishWebsocketConnection())
      .then(registerOnWindowOpenedCallback());
  }

  function establishWebsocketConnection() {
    return function() {
      return sideBySideApi.establishWebsocketConnection();
    };
  }

  function registerOnWindowOpenedCallback() {
    return function() {
      return sideBySideApi.onWindowOpened(function(windowInstance) {
        return RediWindowFactory.createFromEikonWindowInstance(windowInstance);
      });
    };
  }
};



// WEBPACK FOOTER //
// ./app/business/sideBySideInitializer.js